// @flow

export default (unitType: string) => {
  let type = unitType;
  if (unitType.includes('SMS')) {
    type = 'SMS';
  } else if (unitType.includes('ZONED') && unitType.includes('VOICE')) {
    type = 'TO_ZONED_VOICE';
  } else if (unitType.includes('VOICE')) {
    type = 'VOICE';
  } else if (unitType.includes('ROA') && unitType.includes('DATA')) {
    type = 'ROA_DATA';
  } else if (unitType.includes('DATA')) {
    type = 'DATA';
  }
  return type;
};
